import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { colorSets } from '@swimlane/ngx-charts/release/utils';
import { DonutOptions } from '../../../utils/models/donut-options';
import { customColorSets } from '../../../utils/custom-color-sets';

/**
 * Donut chart component
 * @author Prasanth Venkatesan
 */
@Component({
    selector: 'neu-charts-donut',
    template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-pie-chart 
        [scheme]="colorScheme"
        [results]="data"
        [legend]="options.showLegend"
        [explodeSlices]="options.explodeSlices"
        [labels]="options.showLabels"
        [doughnut]="options.doughnut"
        [arcWidth]="options.arcWidth"
        [gradient]="gradient"
        (select)="mSelectedEvent($event)">
        </ngx-charts-pie-chart>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
    styles: [`.chart-container{width:100%;height:100%}`]
})
export class DonutChartComponent implements OnInit {

    @Input('data') data: any[] = [];
    @Input('options') cutomOptions: DonutOptions;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: DonutOptions = new DonutOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {   
        Object.assign(this.options, this.cutomOptions);
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
